import { render, staticRenderFns } from "./DetalhesVencedoresLoteTable.vue?vue&type=template&id=33100638&scoped=true"
import script from "./DetalhesVencedoresLoteTable.vue?vue&type=script&lang=ts"
export * from "./DetalhesVencedoresLoteTable.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33100638",
  null
  
)

export default component.exports